"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ScaleNumber_1 = __importDefault(require("../../ScaleNumber"));
var Price_1 = __importDefault(require("../Price"));
var ItemImage_1 = __importDefault(require("./ItemImage"));
var itemTableStyles = {
    table: {
        width: '100%'
    },
    bottomTable: {
        width: '100%',
        position: 'absolute',
        bottom: 0
    }
};
var ItemTable = function (_a) {
    var _b = _a.product, productId = _b.productId, imagePath = _b.imagePath, scaleNumber = _b.scaleNumber, unit = _b.unit, itemsCount = _a.itemsCount, itemImageStyles = _a.itemImageStyles, scaleNumberLabel = _a.scaleNumberLabel, scaleNumberStyles = _a.scaleNumberStyles, itemPriceStyles = _a.itemPriceStyles, itemPriceUnitStyles = _a.itemPriceUnitStyles, priceIntegers = _a.priceIntegers, priceDecimals = _a.priceDecimals, hasImage = _a.hasImage;
    var itemImageProps = {
        productId: productId,
        imagePath: imagePath,
        itemsCount: itemsCount,
        itemImageStyles: itemImageStyles,
        hasImage: hasImage
    };
    if (itemsCount === 1) {
        return (react_1.default.createElement("table", { style: itemTableStyles.table },
            react_1.default.createElement("tbody", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(ItemImage_1.default, __assign({}, itemImageProps)),
                        react_1.default.createElement(ScaleNumber_1.default, { label: scaleNumberLabel, useAsImage: !hasImage, styles: scaleNumberStyles, scaleNumber: scaleNumber, itemsCount: itemsCount })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(Price_1.default, { styles: itemPriceStyles, priceUnitStyles: itemPriceUnitStyles, priceIntegers: priceIntegers, priceDecimals: priceDecimals, unit: unit, itemsCount: itemsCount }))))));
    }
    if (itemsCount === 2) {
        return (react_1.default.createElement("table", { style: itemTableStyles.table },
            react_1.default.createElement("tbody", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", { colSpan: 2 },
                        react_1.default.createElement(ItemImage_1.default, __assign({}, itemImageProps)))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(ScaleNumber_1.default, { label: scaleNumberLabel, useAsImage: !hasImage, styles: scaleNumberStyles, scaleNumber: scaleNumber, itemsCount: itemsCount })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(Price_1.default, { styles: itemPriceStyles, priceUnitStyles: itemPriceUnitStyles, priceIntegers: priceIntegers, priceDecimals: priceDecimals, unit: unit, itemsCount: itemsCount }))))));
    }
    return (react_1.default.createElement("table", { style: itemTableStyles.table },
        react_1.default.createElement("tbody", null,
            react_1.default.createElement("tr", null,
                react_1.default.createElement("td", null,
                    react_1.default.createElement(ItemImage_1.default, __assign({}, itemImageProps)),
                    react_1.default.createElement(ScaleNumber_1.default, { label: scaleNumberLabel, useAsImage: !hasImage, styles: scaleNumberStyles, scaleNumber: scaleNumber, itemsCount: itemsCount })),
                react_1.default.createElement("td", null,
                    react_1.default.createElement(Price_1.default, { styles: itemPriceStyles, priceUnitStyles: itemPriceUnitStyles, priceIntegers: priceIntegers, priceDecimals: priceDecimals, unit: unit, itemsCount: itemsCount }))))));
};
exports.default = ItemTable;
//# sourceMappingURL=ItemTable.js.map